import React from 'react';
import { StepContainer } from '../StepContainer';
import { FormSection } from './form/formSection';
import { FormItem } from './form/formItem';

interface MenuiserieStepProps {
  data: any;
  onChange: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const MenuiserieStep: React.FC<MenuiserieStepProps> = ({
  data = {
    menuiseriesExterieures: {},
    volets: {},
    menuiseriesInterieures: {},
    serrurerie: {},
    portesGaragePortails: {}
  },
  onChange,
  onNext,
  onBack
}) => {
  const updateSection = (section: string, key: string, value: any) => {
    onChange({
      ...data,
      [section]: {
        ...data[section],
        [key]: value
      }
    });
  };

  return (
    <StepContainer
      title="Menuiseries et Serrurerie"
      description="Détaillez les travaux de menuiseries à réaliser"
      onNext={onNext}
      onBack={onBack}
    >
      <div className="space-y-6">
        <FormSection
          title="1. Menuiseries extérieures"
          description="Fenêtres et portes extérieures"
        >
          <div className="space-y-4">
            <FormItem
              label="Fenêtres PVC double vitrage avec pose"
              value={data.menuiseriesExterieures?.fenetrePvc || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'fenetrePvc', value)}
              withQuantity
            />
            <FormItem
              label="Fenêtres PVC triple vitrage avec pose"
              value={data.menuiseriesExterieures?.fenetrepvctriple || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'fenetrepvctriple', value)}
              withQuantity
            />
            <FormItem
              label="Fenêtres aluminium double vitrage avec pose"
              value={data.menuiseriesExterieures?.fenetreAlu || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'fenetreAlu', value)}
              withQuantity
            />
            <FormItem
              label="Fenêtres bois double vitrage avec pose"
              value={data.menuiseriesExterieures?.fenetreBois || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'fenetreBois', value)}
              withQuantity
            />
            <FormItem
              label="Petit vélux (exemple : 78 x 98 cm) avec pose"
              value={data.menuiseriesExterieures?.petitvelux || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'petitvelux', value)}
              withQuantity
            />
            <FormItem
              label="Grand vélux (exemple : 114 x 118 cm) avec pose"
              value={data.menuiseriesExterieures?.grandvelux || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'grandvelux', value)}
              withQuantity
            />            
            <FormItem
              label="Soupirail de cave avec pose"
              value={data.menuiseriesExterieures?.soupirail || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'soupirail', value)}
              withQuantity
            />
            <FormItem
              label="Porte fenêtre 1 ouvrant standard + 1 vitre fixe avec pose"
              value={data.menuiseriesExterieures?.portefenetreunouvrantunfixe || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'portefenetreunouvrantunfixe', value)}
              withQuantity
            />
            <FormItem
              label="Porte fenêtre 1 ouvrant coulissant + 1 vitre fixe avec pose"
              value={data.menuiseriesExterieures?.portefenetreuncoulissantunfixe || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'portefenetreuncoulissantunfixe', value)}
              withQuantity
            />
            <FormItem
              label="Porte fenêtre 2 ouvrants standards avec pose"
              value={data.menuiseriesExterieures?.portefenetredeuxouvrants || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'portefenetredeuxouvrants', value)}
              withQuantity
            />
             <FormItem
              label="Porte fenêtre 2 ouvrants coulissants avec pose"
              value={data.menuiseriesExterieures?.portefenetredeuxcoulissants || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'portefenetredeuxcoulissants', value)}
              withQuantity
            />
            <FormItem
              label="Porte d'entrée standard avec pose"
              value={data.menuiseriesExterieures?.porteEntree || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'porteEntree', value)}
              withQuantity
            />
            <FormItem
              label="Porte d'entrée blindée avec pose"
              value={data.menuiseriesExterieures?.porteBlindee || { selected: false }}
              onChange={(value) => updateSection('menuiseriesExterieures', 'porteBlindee', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="2. Volets"
          description="Installation ou remplacement de volets (en alumnium isolé)"
        >
          <div className="space-y-4">
            <FormItem
              label="Volet pour fenêtre standard avec pose - ouverture manuelle"
              value={data.volets?.fenetrestandardmanuel || { selected: false }}
              onChange={(value) => updateSection('volets', 'fenetrestandardmanuel', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour fenêtre standard avec pose - ouverture électrique"
              value={data.volets?.fenetrestandardelectrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'fenetrestandardelectrique', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour grande fenêtre (exemple : 150 x 130 cm) avec pose - ouverture manuelle"
              value={data.volets?.grandefenetremanuel || { selected: false }}
              onChange={(value) => updateSection('volets', 'grandefenetremanuel', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour grande fenêtre (exemple : 150 x 130 cm) avec pose - ouverture électrique"
              value={data.volets?.grandefenetreelectrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'grandefenetreelectrique', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour porte fenêtre standard (exemple : 180 x 210 cm) avec pose - ouverture manuelle"
              value={data.volets?.portefenetrestandardmanuel || { selected: false }}
              onChange={(value) => updateSection('volets', 'portefenetrestandardmanuel', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour porte fenêtre standard (exemple : 180 x 210 cm) avec pose - ouverture électrique"
              value={data.volets?.portefenetrestandardelectrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'portefenetrestandardelectrique', value)}
              withQuantity
            />
            <FormItem
              label="Volet sur mesure très grande taille (exemple 190 x 240 cm) avec pose - ouverture manuelle"
              value={data.volets?.tresgrande_manuelle || { selected: false }}
              onChange={(value) => updateSection('volets', 'tresgrande_manuelle', value)}
              withQuantity
            />
            <FormItem
              label="Volet sur mesure très grande taille (exemple 190 x 240 cm) avec pose - ouverture électrique"
              value={data.volets?.tresgrande_electrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'tresgrande_electrique', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour petit vélux (exemple : 78 x 98 cm) avec pose - ouverture manuelle"
              value={data.volets?.petitveluxmanuel || { selected: false }}
              onChange={(value) => updateSection('volets', 'petitveluxmanuel', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour petit vélux (exemple : 78 x 98 cm) avec pose - ouverture électrique"
              value={data.volets?.petitveluxelectrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'petitveluxelectrique', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour grand vélux (exemple : 114 x 118 cm) avec pose - ouverture manuelle"
              value={data.volets?.grandveluxmanuel || { selected: false }}
              onChange={(value) => updateSection('volets', 'grandveluxmanuel', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour grand vélux (exemple : 114 x 118 cm) avec pose - ouverture électrique"
              value={data.volets?.grandveluxelectrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'grandveluxelectrique', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour porte d'entrée avec pose - ouverture manuelle"
              value={data.volets?.porteentreemanuel || { selected: false }}
              onChange={(value) => updateSection('volets', 'porteentreemanuel', value)}
              withQuantity
            />
            <FormItem
              label="Volet pour porte d'entrée avec pose - ouverture électrique"
              value={data.volets?.porteentreeelectrique || { selected: false }}
              onChange={(value) => updateSection('volets', 'porteentreeelectrique', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="3. Menuiseries intérieures"
          description="Portes intérieures et placards"
        >
          <div className="space-y-4">
            <FormItem
              label="Porte intérieure standard avec pose"
              value={data.menuiseriesInterieures?.porteStandard || { selected: false }}
              onChange={(value) => updateSection('menuiseriesInterieures', 'porteStandard', value)}
              withQuantity
            />
            <FormItem
              label="Porte intérieure coulissante avec pose"
              value={data.menuiseriesInterieures?.porteCoulissante || { selected: false }}
              onChange={(value) => updateSection('menuiseriesInterieures', 'porteCoulissante', value)}
              withQuantity
            />
            <FormItem
              label="Placard standard avec portes coulissantes avec pose"
              value={data.menuiseriesInterieures?.placardStandard || { selected: false }}
              onChange={(value) => updateSection('menuiseriesInterieures', 'placardStandard', value)}
              withLength
            />
            <FormItem
              label="Dressing sur mesure avec pose"
              value={data.menuiseriesInterieures?.dressing || { selected: false }}
              onChange={(value) => updateSection('menuiseriesInterieures', 'dressing', value)}
              withLength
            />
          </div>
        </FormSection>

        <FormSection
          title="4. Serrurerie"
          description="Serrures et garde-corps"
        >
          <div className="space-y-4">
            <FormItem
              label="Serrure de sécurité standard"
              value={data.serrurerie?.serrureStandard || { selected: false }}
              onChange={(value) => updateSection('serrurerie', 'serrureStandard', value)}
              withQuantity
            />
            <FormItem
              label="Serrure connectée"
              value={data.serrurerie?.serrureConnectee || { selected: false }}
              onChange={(value) => updateSection('serrurerie', 'serrureConnectee', value)}
              withQuantity
            />
            <FormItem
              label="Garde-corps en acier"
              value={data.serrurerie?.gardeCorpsAcier || { selected: false }}
              onChange={(value) => updateSection('serrurerie', 'gardeCorpsAcier', value)}
              withLength
            />
            <FormItem
              label="Garde-corps en verre"
              value={data.serrurerie?.gardeCorpsVerre || { selected: false }}
              onChange={(value) => updateSection('serrurerie', 'gardeCorpsVerre', value)}
              withLength
            />
          </div>
        </FormSection>

        <FormSection
          title="5. Portes de garage et portails"
          description="Portes de garage et portails d'entrée"
        >
          <div className="space-y-4">
            <FormItem
              label="Porte de garage sectionnelle motorisée"
              value={data.portesGaragePortails?.porteGarageSectionnelle || { selected: false }}
              onChange={(value) => updateSection('portesGaragePortails', 'porteGarageSectionnelle', value)}
              withQuantity
            />
            <FormItem
              label="Porte de garage basculante motorisée"
              value={data.portesGaragePortails?.porteGarageBasculante || { selected: false }}
              onChange={(value) => updateSection('portesGaragePortails', 'porteGarageBasculante', value)}
              withQuantity
            />
            <FormItem
              label="Porte de garage basculante sans motorisation"
              value={data.portesGaragePortails?.porteGarage || { selected: false }}
              onChange={(value) => updateSection('portesGaragePortails', 'porteGarage', value)}
              withQuantity
            />
          </div>
        </FormSection>
      </div>
    </StepContainer>
  );
};

export default MenuiserieStep;